<template>
  <f-group :label="label" :id="id" :required="required" :tooltip="tooltip" :hint="hint" :error="error">
    <input
      :type="type"
      :class="['form-control', isDateType && 'form-date', error && 'is-invalid']"
      :id="id"
      :value="value"
      :required="required"
      :disabled="disabled"
      :placeholder="placeholder"
      :maxlength="maxlength"
      :pattern="pattern"
      :min="min"
      :max="max"
      autocomplete="off"
      @keydown="blockBelowMinKey($event)"
      @input="onInput($event)"
    >
  </f-group>
</template>

<script>
import FGroup from './Base/FGroup'

export default {
  name: 'FText',
  components: { FGroup },
  props: {
    value: { default: '' },
    label: String,
    id: { type: String, required: true },
    type: { default: 'text' },
    min: { default: null },
    max: { default: null },
    required: Boolean,
    disabled: Boolean,
    placeholder: String,
    maxlength: { type: [String, Number], default: null },
    pattern: { type: String, default: null },
    tooltip: String,
    hint: String,
    error: { type: String, default: null }
  },
  computed: {
    isDateType() {
      return this.type === 'date' || this.type === 'datetime-local'
    },
    // "-" is only ever invalid input when a non-negative min is enforced
    blocksMinus() {
      return this.type === 'number' && this.min != null && Number(this.min) >= 0
    }
  },
  methods: {
    blockBelowMinKey(event) {
      if (this.blocksMinus && event.key === '-') event.preventDefault()
    },
    onInput(event) {
      let val = event.target.value
      // Guards against a pasted negative value slipping past the keydown block above
      if (this.blocksMinus && val !== '' && Number(val) < Number(this.min)) {
        val = val.replace('-', '')
        event.target.value = val
      }
      // Clamps a typed/pasted value above max — native :max only blocks the spinner, not typing
      if (this.type === 'number' && this.max != null && val !== '' && Number(val) > Number(this.max)) {
        val = String(this.max)
        event.target.value = val
      }
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FormFields/FText.vue